module.exports = __webpack_public_path__ + "img/803-765822.png";